import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/sales.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, DatePicker, Tabs, List, ListItem, IconReload, Checkbox, Accordion, AccordionItemInterface, IconX, IconCheckmark, AccordionInterface, IconCheckmarkCircle, Card, IconSave, TextArea, IconXCircle } from "@veneer/core";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import salesService from "../../services/agendaApi/sales.service";
import { ISaleDetailsDto, ISaleDto } from "../../models/dto/agendaApi/ISaleDto";
import { NumberFormatBase } from 'react-number-format';
import BackButton from "../../features/path/backButton";

import moment from "moment";

import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ICategoriesDto } from "../../models/dto/agendaApi/ICategoriesDto";
import { IImpresionProductDto } from "../../models/dto/agendaApi/IImpresionProductDto";
import { IPcProductsDto, IPrintProductsDto, ISaleIn } from "../../models/input/agendaApi/ISaleIn";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { CountryEnum } from "../../models/enum/CountryEnum";
import { decryptText } from "../../utils/encryptionUtils";

export default function SalesAppointment() {

    const params = useParams();
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    type SelectValue = number | string | boolean; //CHECK
    const state: any = useSelector((state: RootState) => state.user);


    const [country, setCountry] = useState(NaN);
    const [brandId, setBrandId] = useState(NaN);

    //Loadings
    const [loadingTableData, setLoadingTableData] = useState(false);

    //shows
    const [showModalRegisterSale, setShowModalRegisterSale] = useState(false);
    const [showModalSaleDetails, setShowModalSaleDetails] = useState(false);
    const [showModalRegisterZeroSale, setShowModalRegisterZeroSale] = useState(false);
    const [showButtonRegisterZeroSale, setShowButtonRegisterZeroSale] = useState(false);
    const [showButtonsRegisterSale, setShowButtonsRegisterSale] = useState(false);




    //Date
    const [date, setDate] = useState<string>('');
    const [saleDate, setSaleDate] = useState<string>('');

    //Times
    const [saleTime, setSaleTime] = useState<string | moment.Moment | null>(null);


    //Selects
    const [brandSelected, setBrandSelected] = useState<SelectValue[]>([]);

    //Data
    const [tableData, setTableData] = useState<TableData[]>([]);
    const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
    const [brands, setBrands] = useState<SelectOption[]>([]);
    const [impressionData, setImpressionData] = useState<SelectOption[]>([]);
    const [impressionDataFiltered, setImpressionDataFiltered] = useState<SelectOption[]>([]);
    const [categories, setCategories] = useState<ICategoriesDto[]>([]);
    const [subcategories, setSubcategories] = useState<ICategoriesDto[]>([]);
    const [printProducts, setPrintProducts] = useState<IPrintProductsDto[]>([]);
    const [saleSelected, setSaleSelected] = useState<ISaleDetailsDto>();
    const [noteNumber, setNoteNumber] = useState<string>('');
    const [sellerName, setSellerName] = useState<string>('');
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
    const [activityId, setActivityId] = useState(NaN);
    const [viewSaleModal, setViewSaleModal] = useState<number>(0);
    const [notes, setNotes] = useState<string>('');






    const actualPosCode = useRef('');
    let tableDataConsult: TableData[] = [];

    //Tab
    const [selectedRegisterSaleTab, setSelectedRegisterSaleTab] = useState<number>(0);

    //Checkbox
    const [checkboxOnline, setCheckboxOnline] = useState<boolean>(false);

    //Disables
    const [registerSaleButtonDisable, setRegisterSaleButtonDisable] = useState(true);
    const [submitRegisterSaleButtonDisable, setSubmitRegisterSaleButtonDisable] = useState(true);
    const [registerZeroSaleButtonDisable, setRegisterZeroSaleButtonDisable] = useState(true);


    useEffect(() => {
        getBrandsData()
        let today = new Date()
        setDate(String(today))
        let id = Number(params.id);
        let activityId = Number(params.activityId);
        setActivityId(id)
        setAppointmentActivityId(activityId);
    }, [])


    useEffect(() => {
        if (!Number.isNaN(brandId) && date !== '') {
            getTableData()
            setRegisterSaleButtonDisable(false)
            setRegisterZeroSaleButtonDisable(false)
        } else {
            setRegisterSaleButtonDisable(true)
            setRegisterZeroSaleButtonDisable(true)
        }
    }, [brandId, date])

    useEffect(() => {
        if (tableData.length > 0) {
            setShowButtonRegisterZeroSale(false);
        } else {
            setShowButtonRegisterZeroSale(true);
        }
    }, [tableData])


    useEffect(() => {
        if (saleDate !== '' && saleTime !== null) {
            if (printProducts.length !== 0) {
                let printProductsValidation = printProducts.some(item => { return (Number.isNaN(item.quantity) || item.quantity === 0) });
                if (printProductsValidation) {
                    setSubmitRegisterSaleButtonDisable(true)

                } else {
                    setSubmitRegisterSaleButtonDisable(false)
                }
            } else {
                let pcProductsValidation = subcategories.some(item => { return (!Number.isNaN(item.quantity)) });
                if (pcProductsValidation) {
                    setSubmitRegisterSaleButtonDisable(false)
                } else {
                    setSubmitRegisterSaleButtonDisable(true)
                }
            }
        } else {
            setSubmitRegisterSaleButtonDisable(true)
        }
    }, [saleDate, saleTime, subcategories, printProducts])

    useEffect(() => {
    }, [expandedIndex])

    useEffect(() => {
        let actualDate = moment(new Date())
        if(moment(date).diff(actualDate, 'days') <= -2){
            setShowButtonsRegisterSale(false);
        }else {
            setShowButtonsRegisterSale(true);
        }
    }, [date])
    

    const getBrandsData = () => {
        setCountry(Number(decryptText(state.user.countryId))) //13
        let id = Number(params.id);
        appointmentService.getAppointmentByUser()
            .then(r => {
                getPosCode(r, id)
            })

    }

    const getTableData = () => {
        setLoadingTableData(true)
        getSales(actualPosCode.current)

    }

    const getPosCode = (data: IAppointmentDto[], id: number) => {
        let posCode = data.find(x => x.appointmentId === id)?.posCode;
        if (posCode) {
            actualPosCode.current = posCode;
            salesService.getBrandsByPos(posCode).then(r => {
                fillBrands(r)
            });
        } else { alert("Error") }
    }


    const getSales = (posCode: string) => {
        salesService.getSales(posCode, brandId, formatDate2(String(date)), languageId.value)
            .then(r => {
                fillDataSales(r)
            }).finally(() => {
                setLoadingTableData(false)
                getDataForCreation()
            });
    }

    const getDataForCreation = () => {
        salesService.GetSubcategoriesByLanguage(languageId.value)
            .then(s => {
                fillDataSubcategories(s)
            }).then(() => {
                salesService.GetCategoriesByLanguage(languageId.value, actualPosCode.current, brandId)
                    .then(r => {
                        setCategories(r)
                    })
            })
        salesService.GetImpresionProducts(actualPosCode.current, brandId)
            .then(r => {
                fillImpresionProducts(r)
            }).finally(() => setLoadingTableData(false));
    }



    const fillBrands = (data: IBrandDto[]) => {
        const brandsTemp: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const brand: IBrandDto = data[i];
            let brandTemp: SelectOption;
            brandTemp = {
                'value': brand.brandID,
                'label': brand.brandName,
            }
            brandsTemp.push(brandTemp);
        }
        setBrands(brandsTemp);
        setBrandId(Number(brandsTemp[0].value))
        setBrandSelected([brandsTemp[0].value])
    }


    const fillDataSales = (data: ISaleDto[]) => {
        const pagedData: TableData[] = [];
        for (let i = 0; i < data.length; i++) {
            const sale: ISaleDto = data[i];
            let tableData: TableData = {};
            tableData = {
                'salesDate': formatDate1(String(sale.salesDate)),
                'units': sale.units,
                'online': sale.online === 1 ? <IconCheckmark /> : <IconX />,
                'pcProducts': sale.pcProducts,
                'printProducts': sale.printProducts,
                'rowConfig': {
                    action: <ContextualMenu
                        onClick={handleActionRowConfig}
                        options={[
                            { value: i, label: t("header.details"), icon: <IconPencil /> },
                        ]}
                        placement="leading"
                    />,
                    disabled: false,
                    noWrap: false,
                    selected: false,

                },
                'pcProductsLabel': sale.pcProducts ? JSON.parse(sale.pcProducts).map((item: any) => item.Category).join('\n') : <IconXCircle />,
                'printProductsLabel': sale.printProducts ? JSON.parse(sale.printProducts).map((item: any) => item.ProductName).join('\n') : <IconXCircle />,

            }
            pagedData.push(tableData);
        }
        setTableData(pagedData);
        setTableDataFiltered(pagedData);
        tableDataConsult = pagedData;


    }

    const fillImpresionProducts = (data: IImpresionProductDto[]) => {
        const impresionProductsTemp: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const impresion: IImpresionProductDto = data[i];
            let impresionTemp: SelectOption;
            impresionTemp = {
                'value': impresion.sku,
                'label': impresion.productName,
            }
            impresionProductsTemp.push(impresionTemp);
        }
        setImpressionData(impresionProductsTemp);
        setImpressionDataFiltered(impresionProductsTemp)
    }


    const fillDataSubcategories = (data: ICategoriesDto[]) => {
        const subcategoriesTemp: ICategoriesDto[] = [];

        for (let i = 0; i < data.length; i++) {
            const subcategory: ICategoriesDto = data[i];
            let subcategoryTemp: ICategoriesDto;
            subcategoryTemp = {
                ...subcategory,
                'quantity': NaN

            }
            subcategoriesTemp.push(subcategoryTemp);
        }
        setSubcategories(subcategoriesTemp);
    }


    const accordionData = React.useMemo(
        () =>
            categories.map((category, indexCategory) => {
                const id: string = `item-${indexCategory}`;
                const expanded = indexCategory === expandedIndex;
                let subcategoriesActual: ICategoriesDto[] = subcategories.filter((item) => {
                    return item.parent === category.categoryID;
                })
                let validationValues = subcategoriesActual.some((item) => {
                    return !Number.isNaN(item.quantity);
                })
                return {
                    ...category,
                    id: expanded ? 'listItemExpanded' : id,
                    expanded,
                    header: {
                        centralArea: <></>,
                        endArea: <></>,
                        startArea: validationValues ? <>{category.category} &nbsp; <IconCheckmarkCircle filled color="colorLightGreen6" /></> : <>{category.category}</>,
                    },
                    content: (
                        subcategories.map((item, index) => {
                            if (item.parent === category.categoryID) {
                                return (
                                    <ListItem
                                        key={index}
                                        centerArea={
                                            <>
                                                <p>{item.category}</p>
                                            </>}
                                        trailingArea={

                                            <TextBox
                                                id={index + "textfieldsCreateSale"}
                                                className="textfieldsCreateSale"
                                                type="number"
                                                maxLength={3}
                                                value={String(item.quantity)}
                                                onChange={e => handleChangePcProducts(index, String(e))}
                                                inputComponent={NumberFormatBase}

                                            />
                                        }
                                    ></ListItem>
                                )
                            }

                        }))

                };
            }),
        [categories, subcategories, expandedIndex]
    );





    function formatDate2(date: string) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const formatDate1 = (date: string) => {
        let timestamp = Date.parse(date);
        if (isNaN(timestamp) === false) {
            let dateTemp = new Date(date);
            return dateTemp.toLocaleDateString('en-GB').split('/').join('/');
        } else {
            return ""
        }
    }



    const columns: TableColumns[] = [
        {
            id: 'units',
            label: t("header.units"),
        },
        {
            id: 'pcProductsLabel',
            label: t("header.pcProducts"),
        },
        {
            id: 'printProductsLabel',
            label: t("header.printProducts"),
        }
    ];

    const columnsWidth: TableColumnWidth[] = [
        {
            columnId: 'units',
            width: "20%"
        },
        {
            columnId: 'pcProducts',
            width: "40%"
        },
        {
            columnId: 'printProducts',
            width: "40%"
        }
    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }


    const handleActionRowConfig = (e: React.SyntheticEvent, option?: OptionInterface) => {
        if (option) {
            const saleSelectedTable = tableDataConsult[Number(option.value)];
            if (saleSelectedTable) {
                const arrayPcProducts = saleSelectedTable.pcProducts ? JSON.parse(saleSelectedTable.pcProducts) : null
                const arrayPrintProducts = saleSelectedTable.printProducts ? JSON.parse(saleSelectedTable.printProducts) : null

                const saleSelectedTemp: ISaleDetailsDto = {
                    units: saleSelectedTable.units,
                    pcProducts: arrayPcProducts,
                    printProducts: arrayPrintProducts
                }
                setSaleSelected(saleSelectedTemp)
                setShowModalSaleDetails(true)
            }

        }

    }


    const handleChangeBrand = (value: SelectValue) => {
        setBrandId(Number(value));
        setBrandSelected([value])
    }

    const handleChangeDate = (newDate: string) => {
        setDate(newDate);
    };


    const handleChangeNoteNumber = (value: string) => {
        setNoteNumber(value);
    };

    const handleChangeSellerName = (value: string) => {
        setSellerName(value);
    };

    const handleChangeNotes = (value: string) => {
        setNotes(value);
    };


    const handleChangePcProducts = (index: number, value: string) => {
        if (value === '') {
            const updatedData = subcategories;
            updatedData[index].quantity = NaN;
            setSubcategories([...updatedData]);
        } else {
            const updatedData = subcategories;
            updatedData[index].quantity = Number(value);
            setSubcategories([...updatedData]);
        }
    }

    const handleChangeImpression = (value: SelectValue) => {
        const product = impressionData.find(x => x.value === value);
        const impressionDataFiltered = impressionData.filter(item => {
            return item.value !== value;
        })
        setImpressionData([...impressionDataFiltered]);
        setImpressionDataFiltered([...impressionDataFiltered])

        if (product) {
            const updatedData = printProducts;
            updatedData.push({
                sku: String(product.value),
                productName: String(product.label),
                quantity: NaN
            })

            setPrintProducts([...updatedData]);
        }



    }

    const handleChangePrintProducts = (index: number, value: string) => {
        const updatedData = printProducts;
        updatedData[index].quantity = Number(value);
        setPrintProducts([...updatedData]);
    }


    const handleChangeDeletePrintProducts = (item: IPrintProductsDto) => {
        const printProductsFiltered = printProducts.filter(itemPrint => {
            return itemPrint.sku !== item.sku;
        })
        setPrintProducts([...printProductsFiltered]);

        const updatedData = impressionData;
        impressionData.push({
            value: String(item.sku),
            label: String(item.productName)
        })

        setImpressionData([...updatedData]);
        setImpressionDataFiltered([...updatedData])



    }


    const handleChangeSearchSelect = (value: string) => {
        const filterArray = impressionData.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setImpressionDataFiltered(filterArray)
    }

    const handleChangeCheckboxOnline = () => {
        setCheckboxOnline(!checkboxOnline);
    }


    const clearPcValues = () => {

        const updatedData = subcategories;
        for (let i = 0; i < updatedData.length; i++) {
            updatedData[i].quantity = NaN;
        }
        setSubcategories([...updatedData]);
        setExpandedIndex(null)
    }

    const onClearBrand = () => {
        setBrandId(NaN);
        setBrandSelected([])
        setTableData([]);
        setTableDataFiltered([]);
        tableDataConsult = [];

    }

    const onRegisterSale = () => {
        setShowModalRegisterSale(true)
        setActualDate()
    }

    const onRegisterZeroSale = () => {
        setShowModalRegisterZeroSale(true)
        setActualDate()
    }

    const setActualDate = () => {
        let dateTemp = new Date(date)
        setSaleDate(String(dateTemp));
        setSaleTime(moment(dateTemp));
    }

    const resetFormat = () => {
        setSaleDate('')
        setSaleTime(null)
        setPrintProducts([])
        setSelectedRegisterSaleTab(0)
        setNoteNumber('');
        setSellerName('');
        clearPcValues();
        setViewSaleModal(0)
        setNotes('')
        setCheckboxOnline(false)
    }



    const submitRegisterSale = () => {
        let dateTime = new Date(formatDate2(String(saleDate)) + " " + moment(String(saleTime)).format("HH:mm:ss"))
        let date = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toJSON();;

        let activityId = Number(params.activityId);

        const subcategoriesTemp = subcategories.filter(x => !Number.isNaN(x.quantity));
        const pcProducts: IPcProductsDto[] = []
        subcategoriesTemp.map((item, index) => {
            pcProducts.push({
                subCategoryID: item.categoryID,
                quantity: item.quantity ? item.quantity : NaN
            })
        });
        let saleIn: ISaleIn[] = [{
            appointmentActivityID: activityId,
            brandID: brandId,
            date: date,
            online: String(checkboxOnline),
            pcProducts: pcProducts,
            printProducts: printProducts,
            noteNumber: noteNumber !== '' ? Number(noteNumber) : 0,
            sellerName: sellerName,
            notes: notes

        }]
        salesService.insertSale(saleIn)
            .then(r => {
                setShowModalRegisterSale(false)
                resetFormat()
                getTableData()
            })


    }

    const submitRegisterZeroSale = () => {

        let dateTime = new Date(formatDate2(String(saleDate)) + " " + moment(String(saleTime)).format("HH:mm:ss"))
        let date = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toJSON();;
        let activityId = Number(params.activityId);

        let saleIn: ISaleIn[] = [{
            appointmentActivityID: activityId,
            brandID: brandId,
            date: date,
            online: 'false',
            pcProducts: [],
            printProducts: [],
            noteNumber: 0,
            sellerName: '',
            notes: ''

        }]
        salesService.insertSale(saleIn)
            .then(r => {
                setShowModalRegisterZeroSale(false)
                resetFormat()
                getTableData()
            })

    }

    const cancelRegisterSale = () => {
        setShowModalRegisterSale(false)
        resetFormat()
    }

    const toggleExpand: AccordionInterface['onExpand'] = (event, index) => {
        if (expandedIndex === index) {
            setExpandedIndex(null);
        } else {
            setExpandedIndex(index);
        }
    };


    return (
        <>

            {
                (() => {
                    if (Number.isNaN(country)) {
                        return (<div></div>)
                    } else {
                        return (
                            <div className="sales">
                                <BackButton route={BreadCrumbsEnum.Sales} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                                <h4 className="salesTitle">{t("header.sales")}</h4>
                                <div className="salesTop">
                                    <Select
                                        className="salesSelectBrand"
                                        label={t("header.brands")}
                                        onChange={e => handleChangeBrand(e.value)}
                                        onClear={onClearBrand}
                                        options={brands}
                                        value={brandSelected}
                                        placement="bottom-start"
                                    />

                                    {showButtonsRegisterSale && (
                                        <>
                                            {(() => {
                                                if (brandId === 1) {
                                                    return (
                                                        <ButtonGroup className="salesButtongroupTop">
                                                            {showButtonRegisterZeroSale ? <Button className="salesButtonTop" appearance="secondary" onClick={onRegisterZeroSale} disabled={registerZeroSaleButtonDisable}>{t("header.registerZeroSale")}</Button> : null}
                                                            <Button className={showButtonRegisterZeroSale ? 'salesButtonTop' : 'salesButtonTopSingle'} onClick={onRegisterSale} disabled={registerSaleButtonDisable}>{t("header.registerSale")}</Button>
                                                        </ButtonGroup>
                                                    )

                                                } else {
                                                    return (
                                                        <ButtonGroup className="salesButtongroupTop">
                                                            <Button className="salesButtonTopSingle" onClick={onRegisterSale} disabled={registerSaleButtonDisable}>{t("header.registerSale")}</Button>
                                                        </ButtonGroup>
                                                    )
                                                }
                                            })()}

                                        </>
                                    )}


                                </div>

                                <Card
                                    appearance="outlined"
                                    className="salesDiv"
                                    content={<>
                                        <DatePicker
                                            className="salesDivDatePicker"
                                            blockFutureDates
                                            calendarOrientation={['right', 'down']}
                                            label={t("header.date")}
                                            onChange={date => handleChangeDate(String(date))}
                                            orientation="horizontal"
                                            placeholder="mm/dd/yyyy"
                                            value={date}
                                        />
                                        <Table
                                            className="priceProductTable"
                                            behavior={{
                                                type: 'singlePage',
                                            }}
                                            columnResize
                                            preferences={tablePreferences}
                                            loading={loadingTableData}
                                            columns={columns}
                                            data={tableDataFiltered}
                                            loadingDataLength={10}
                                            customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                        />
                                    </>}
                                />


                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalRegisterSale"
                                        closeButton={true}
                                        align="center"
                                        id="modalRegisterSale"
                                        show={showModalRegisterSale}
                                        onClose={cancelRegisterSale}
                                        footer={(() => {
                                            if (viewSaleModal === 0) {
                                                return (
                                                    <ButtonGroup className="registerSaleButtongrouop">
                                                        <Button disabled={submitRegisterSaleButtonDisable} onClick={() => setViewSaleModal(1)} >{t("header.next")}</Button>
                                                        <Button onClick={cancelRegisterSale} appearance="secondary">{t("header.cancel")}</Button>
                                                    </ButtonGroup>
                                                )

                                            } else if (viewSaleModal === 1) {
                                                return (
                                                    <ButtonGroup className="registerSaleButtongrouop">
                                                        <Button onClick={() => setViewSaleModal(0)} >{t("header.previous")}</Button>
                                                        <Button onClick={() => setViewSaleModal(2)} >{t("header.next")}</Button>
                                                        <Button onClick={cancelRegisterSale} appearance="secondary">{t("header.cancel")}</Button>
                                                    </ButtonGroup>
                                                )
                                            } else if (viewSaleModal === 2) {
                                                return (
                                                    <ButtonGroup className="registerSaleButtongrouop">
                                                        <Button onClick={() => setViewSaleModal(1)} >{t("header.previous")}</Button>
                                                        <Button disabled={submitRegisterSaleButtonDisable} onClick={submitRegisterSale} >{t("header.submit")}</Button>
                                                        <Button onClick={cancelRegisterSale} appearance="secondary">{t("header.cancel")}</Button>
                                                    </ButtonGroup>
                                                )
                                            }
                                        })()}

                                        title={t("header.registerSale")}
                                    >

                                        {(() => {
                                            if (viewSaleModal === 0) {
                                                return (
                                                    <div
                                                        className="registerSaleTabs"
                                                    >
                                                        {(() => {
                                                            if (brandId === 1) {
                                                                return (
                                                                    <Tabs
                                                                        className="registerSaleTab"
                                                                        controlId="registerSaleTab"
                                                                        mode="extended"
                                                                        onChangeTab={setSelectedRegisterSaleTab}
                                                                        selectedTabId={selectedRegisterSaleTab}
                                                                        tabs={[
                                                                            {
                                                                                id: 0, label: t("header.pcSupplies"), content:
                                                                                    <>
                                                                                        <div className="registerSalePcSupplies">
                                                                                            <Accordion appearance="outlined"
                                                                                                behavior="singleExpand"
                                                                                                items={accordionData}
                                                                                                onCollapse={toggleExpand}
                                                                                                onExpand={toggleExpand}
                                                                                            />
                                                                                        </div>

                                                                                    </>
                                                                            },
                                                                            {
                                                                                id: 1, label: t("header.impression"), content:
                                                                                    <>
                                                                                        <div className="registerSaleImpression">
                                                                                            <Select
                                                                                                className="salesSelectImpression"
                                                                                                label={t("header.impression")}
                                                                                                onChange={e => handleChangeImpression(e.value)}
                                                                                                options={impressionDataFiltered}
                                                                                                placement="bottom-start"
                                                                                                clearIcon={false}
                                                                                                showSearch
                                                                                                onSearch={handleChangeSearchSelect}
                                                                                            />

                                                                                            <List>
                                                                                                {
                                                                                                    printProducts.map((item, index) => {
                                                                                                        return (<ListItem
                                                                                                            centerArea={
                                                                                                                <>
                                                                                                                    <p>{item.productName}</p>
                                                                                                                </>}
                                                                                                            rightArea={
                                                                                                                <>
                                                                                                                    <TextBox
                                                                                                                        className="textfieldsCreateSale"
                                                                                                                        type="number"
                                                                                                                        maxLength={3}
                                                                                                                        value={String(printProducts[index].quantity)}
                                                                                                                        onChange={e => handleChangePrintProducts(index, String(e))}
                                                                                                                        inputComponent={NumberFormatBase}
                                                                                                                    />
                                                                                                                    <Button appearance="ghost"
                                                                                                                        className="saleListButton"
                                                                                                                        leadingIcon={<IconTrash />}
                                                                                                                        onClick={() => handleChangeDeletePrintProducts(item)} />
                                                                                                                </>

                                                                                                            }

                                                                                                        ></ListItem>)
                                                                                                    })
                                                                                                }

                                                                                            </List>



                                                                                        </div>

                                                                                    </>
                                                                            },

                                                                        ]}
                                                                        type="online"
                                                                    />
                                                                )
                                                            } else {
                                                                return (
                                                                    <div className="registerSalePcSupplies">
                                                                        <Accordion appearance="outlined"
                                                                            behavior="singleExpand"
                                                                            items={accordionData}
                                                                            onCollapse={toggleExpand}
                                                                            onExpand={toggleExpand}
                                                                        />
                                                                    </div>
                                                                )
                                                            }
                                                        })()}



                                                    </div>
                                                )

                                            } else if (viewSaleModal === 1) {
                                                return (
                                                    (() => {
                                                        if (country === CountryEnum.brasil1 || country === CountryEnum.brasil2 || country === CountryEnum.brasil3) {
                                                            return (
                                                                <div className="registerSaleTop">
                                                                    <Checkbox
                                                                        className="registerSalePriceCheckbox"
                                                                        id="checkbox"
                                                                        value={checkboxOnline}
                                                                        checked={checkboxOnline}
                                                                        onChange={handleChangeCheckboxOnline}
                                                                        label={t("header.saleOnline")}
                                                                    />
                                                                    <div className="textfieldsBrasil">
                                                                        <TextBox
                                                                            className="textfieldCreateSale"
                                                                            type="number"
                                                                            value={noteNumber}
                                                                            onChange={e => handleChangeNoteNumber(String(e))}
                                                                            label={t("header.noteNumber")}

                                                                        />
                                                                        <TextBox
                                                                            className="textfieldCreateSale"
                                                                            type="text"
                                                                            value={sellerName}
                                                                            onChange={e => handleChangeSellerName(String(e))}
                                                                            label={t("header.sellerName")}

                                                                        />

                                                                    </div>
                                                                    <TextArea
                                                                        className="textAreaCreateSale"
                                                                        label={t("header.notes")}
                                                                        value={notes}
                                                                        onChange={e => handleChangeNotes(String(e))}
                                                                    />

                                                                </div>
                                                            )

                                                        } else {
                                                            return (
                                                                <div className="registerSaleTop">
                                                                    <Checkbox
                                                                        className="registerSalePriceCheckbox"
                                                                        id="checkbox"
                                                                        value={checkboxOnline}
                                                                        checked={checkboxOnline}
                                                                        onChange={handleChangeCheckboxOnline}
                                                                        label={t("header.saleOnline")}
                                                                    />
                                                                    <TextArea
                                                                        className="textAreaCreateSale"
                                                                        label={t("header.notes")}
                                                                        value={notes}
                                                                        onChange={e => handleChangeNotes(String(e))}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                    })()
                                                )
                                            } else if (viewSaleModal === 2) {
                                                return (
                                                    <div>
                                                        <div className="divListDetails">
                                                            <List>
                                                                {subcategories.filter(item => !Number.isNaN(item.quantity)) ?
                                                                    subcategories.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                                                                        return <ListItem id={String(index)} leadingArea={<p>{item.category}</p>} trailingArea={<p>{item.quantity}</p>} />

                                                                    })
                                                                    :
                                                                    <div></div>
                                                                }

                                                            </List>

                                                        </div>

                                                        <div className="divListDetails">
                                                            <List>
                                                                {printProducts.filter(item => !Number.isNaN(item.quantity)) != null ?
                                                                    printProducts.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                                                                        return <ListItem id={String(index)} leadingArea={<p>{item.productName}</p>} trailingArea={<p>{item.quantity}</p>} />

                                                                    })
                                                                    :
                                                                    <div></div>
                                                                }

                                                            </List>

                                                        </div>

                                                        <List>
                                                            {<ListItem leadingArea={<p>{t("header.total")}</p>} trailingArea={<p>{Number(subcategories.filter(item => !Number.isNaN(item.quantity)).reduce((acum, current) => acum + current.quantity!, 0)) + Number(printProducts.filter(item => !Number.isNaN(item.quantity)).reduce((acum, current) => acum + current.quantity!, 0))}</p>} />}
                                                        </List>


                                                    </div>
                                                )
                                            }
                                        })()}




                                    </Modal>
                                </div>

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalSaleDetails"
                                        closeButton={true}
                                        align="center"
                                        id="modalSaleDetails"
                                        show={showModalSaleDetails}
                                        onClose={() => setShowModalSaleDetails(false)}
                                        title={t("header.saleSummary")}
                                    >
                                        <div>
                                            <div className="divListDetails">
                                                <List>
                                                    {saleSelected?.pcProducts != null ?
                                                        saleSelected.pcProducts.map((item, index) => {
                                                            return <ListItem id={String(index)} leadingArea={<p>{item.Category}</p>} trailingArea={<p>{item.Quantity}</p>} />

                                                        })
                                                        :
                                                        <div></div>
                                                    }

                                                </List>

                                            </div>

                                            <div className="divListDetails">
                                                <List>
                                                    {saleSelected?.printProducts != null ?
                                                        saleSelected.printProducts.map((item, index) => {
                                                            return <ListItem id={String(index)} leadingArea={<p>{item.ProductName}</p>} trailingArea={<p>{item.Quantity}</p>} />

                                                        })
                                                        :
                                                        <div></div>
                                                    }

                                                </List>

                                            </div>

                                            <List>
                                                {<ListItem leadingArea={<p>{t("header.total")}</p>} trailingArea={<p>{saleSelected?.units}</p>} />}
                                            </List>


                                        </div>


                                    </Modal>
                                </div>

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalRegisterZeroSale"
                                        align="center"
                                        id="modalRegisterZeroSale"
                                        show={showModalRegisterZeroSale}
                                        footer={(
                                            <ButtonGroup className="validationTestButtonGroup">
                                                <Button onClick={() => submitRegisterZeroSale()}>{t("header.confirm")}</Button>
                                                <Button onClick={() => setShowModalRegisterZeroSale(false)} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.saveInformation")}
                                    >
                                        <IconSave size={120} />
                                        <br />
                                        <b>{t("header.messageRegisterZeroSale")}</b>
                                    </Modal>
                                </div>



                            </div>
                        )
                    }
                })()
            }

        </>


    );
}